module.exports = __webpack_public_path__ + "img/partido-politico-orden.70b6e375.png";